/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeUser
 */
export interface ChallengeUser {
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeUser
     */
    gravatar?: string;
}

/**
 * Check if a given object implements the ChallengeUser interface.
 */
export function instanceOfChallengeUser(value: object): value is ChallengeUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('nickname' in value) || value['nickname'] === undefined) return false;
    return true;
}

export function ChallengeUserFromJSON(json: any): ChallengeUser {
    return ChallengeUserFromJSONTyped(json, false);
}

export function ChallengeUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nickname': json['nickname'],
        'gravatar': json['gravatar'] == null ? undefined : json['gravatar'],
    };
}

export function ChallengeUserToJSON(json: any): ChallengeUser {
    return ChallengeUserToJSONTyped(json, false);
}

export function ChallengeUserToJSONTyped(value?: ChallengeUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nickname': value['nickname'],
        'gravatar': value['gravatar'],
    };
}

